/* Apprendre.AI, Le Knowledge.
   Mouvement et règles de site. Repris du modèle Mindloop : une montée en fondu
   de 0,6 s, décalée, jouée une seule fois, et respectueuse du mouvement réduit. */
(function () {
  'use strict';

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     1. La montée en fondu, et les images qui se posent
     L'observateur d'intersection fonctionne quel que soit l'élément qui
     défile : au-delà de 990 px, Horizon fait défiler .page-wrapper et non la
     fenêtre, et un écouteur de défilement posé sur window n'y verrait rien.

     Ce bloc était branché une seule fois, au chargement, sur la liste des
     éléments présents à cet instant. Or le panier se recharge tout seul :
     il remplace sa section par une neuve, et cette section arrivait avec ses
     éléments restés à opacité zéro. D'où des recommandations invisibles et
     des visuels qui « ne se chargent pas », que seule une actualisation de
     la page réparait. Tout passe désormais par « paraitre », qui s'applique
     à n'importe quelle racine et se rejoue à chaque nœud neuf.
     ---------------------------------------------------------------------- */
  var oeil = null;
  if (!reduit && 'IntersectionObserver' in window) {
    oeil = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-vu'); oeil.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -100px 0px', threshold: 0 });
  }

  function paraitre(racine) {
    var ou = racine && racine.querySelectorAll ? racine : document;
    var monte = [];
    if (ou.matches && ou.matches('.ml-monte') && !ou.classList.contains('est-vu')) monte.push(ou);
    Array.prototype.push.apply(monte, ou.querySelectorAll('.ml-monte:not(.est-vu)'));
    monte.forEach(function (el) {
      if (oeil) oeil.observe(el); else el.classList.add('est-vu');
    });

    var images = [];
    if (ou.matches && ou.matches('.ml-objet, .ml-vignette img')) images.push(ou);
    Array.prototype.push.apply(images, ou.querySelectorAll('.ml-objet, .ml-vignette img'));
    images.forEach(function (img) {
      if (img.dataset.mlPose) return;
      img.dataset.mlPose = '1';
      if (img.complete && img.naturalWidth > 0) { img.classList.add('est-la'); return; }
      var poser = function () { img.classList.add('est-la'); };
      img.addEventListener('load', poser);
      img.addEventListener('error', poser);
    });

    /* Filet : un onglet ouvert en arrière-plan ne déclenche pas l'observateur,
       et une image qui n'arrive jamais ne doit pas laisser un trou. */
    if (monte.length || images.length) {
      setTimeout(function () {
        monte.forEach(function (el) { el.classList.add('est-vu'); });
        images.forEach(function (img) { img.classList.add('est-la'); });
      }, racine && racine !== document ? 1200 : 6000);
    }
  }

  paraitre(document);

  /* Tout ce qui entre dans la page après coup passe par la même porte :
     le panier rechargé, le tiroir de panier d'Horizon, une fenêtre d'ajout
     rapide. Le balayage est groupé sur une image, jamais par mutation. */
  if ('MutationObserver' in window) {
    var enAttente = false;
    new MutationObserver(function (lots) {
      var neufs = [];
      lots.forEach(function (lot) {
        Array.prototype.forEach.call(lot.addedNodes, function (n) {
          if (n.nodeType === 1) neufs.push(n);
        });
      });
      if (!neufs.length || enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () {
        enAttente = false;
        neufs.forEach(paraitre);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ----------------------------------------------------------------------
     2. Ajout au panier
     Règle de site, sans exception de gabarit : ajouter au panier n'ouvre
     jamais le tiroir. Interrompre quelqu'un qui regarde, c'est le sortir de
     ce qu'il faisait. La pastille de l'en-tête compte, cela suffit.
     ---------------------------------------------------------------------- */
  document.addEventListener('shopify:cart:lines-update', function (ev) {
    if (!ev || ev.action !== 'add') return;
    var tiroir = document.getElementById('cart-drawer');
    if (!tiroir) return;
    var ouvertAvant = tiroir.hasAttribute('open');
    function refermer() {
      if (ouvertAvant || !tiroir.hasAttribute('open')) return;
      if (typeof tiroir.close === 'function') tiroir.close();
      else tiroir.removeAttribute('open');
    }
    Promise.resolve(ev.promise).then(refermer).catch(function () {});
    setTimeout(refermer, 120);
    setTimeout(refermer, 600);
  });

  /* ----------------------------------------------------------------------
     3. Menu de téléphone
     ---------------------------------------------------------------------- */
  var ouvrir = document.querySelector('[data-ml-ouvrir]');
  var tiroirMenu = document.getElementById('ml-tiroir');
  if (ouvrir && tiroirMenu) {
    var dernierFocus = null;
    function ouvre() {
      dernierFocus = document.activeElement;
      tiroirMenu.hidden = false;
      requestAnimationFrame(function () { tiroirMenu.classList.add('est-ouvert'); tiroirMenu.setAttribute('data-ouvert', ''); });
      document.documentElement.classList.add('ml-fige');
      ouvrir.setAttribute('aria-expanded', 'true');
      var premier = tiroirMenu.querySelector('a, button');
      if (premier) premier.focus({ preventScroll: true });
    }
    function ferme() {
      tiroirMenu.classList.remove('est-ouvert');
      tiroirMenu.removeAttribute('data-ouvert');
      document.documentElement.classList.remove('ml-fige');
      ouvrir.setAttribute('aria-expanded', 'false');
      setTimeout(function () { tiroirMenu.hidden = true; }, reduit ? 0 : 300);
      if (dernierFocus && dernierFocus.focus) dernierFocus.focus({ preventScroll: true });
    }
    ouvrir.addEventListener('click', function () { if (tiroirMenu.hidden) ouvre(); else ferme(); });
    tiroirMenu.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ml-fermer]') || ev.target.closest('a')) ferme();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !tiroirMenu.hidden) ferme();
    });
  }


  /* ----------------------------------------------------------------------
     5. La méthode : les mots s'éclairent à mesure que le bloc traverse l'écran.
     Une seule variable de progression est posée sur le bloc ; le CSS s'en sert
     pour chaque mot, ce qui évite de toucher à des centaines d'éléments.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-mots]').forEach(function (bloc) {
    var total = parseInt((bloc.querySelector('[data-ml-total]') || {}).dataset ?
      bloc.querySelector('[data-ml-total]').dataset.mlTotal : '0', 10) || 1;
    bloc.style.setProperty('--total', String(total));
    if (reduit) { bloc.style.setProperty('--p', '1'); return; }
    var attente = false;
    function peindre() {
      attente = false;
      var r = bloc.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      /* de l'entrée à 85 % de l'écran jusqu'à la sortie à 40 % */
      var p = (h * 0.85 - r.top) / (r.height + h * 0.45);
      if (p < 0) p = 0; else if (p > 1) p = 1;
      bloc.style.setProperty('--p', p.toFixed(4));
    }
    document.addEventListener('scroll', function () {
      if (!attente) { attente = true; requestAnimationFrame(peindre); }
    }, { passive: true, capture: true });
    window.addEventListener('resize', peindre, { passive: true });
    peindre();
  });


  /* ----------------------------------------------------------------------
     6. Le sélecteur de niveau : il attend qu'on choisisse, il ne tourne pas.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-niveaux]').forEach(function (bloc) {
    var onglets = Array.prototype.slice.call(bloc.querySelectorAll('[data-ml-onglet]'));
    var fiches = Array.prototype.slice.call(bloc.querySelectorAll('[data-ml-fiche]'));
    if (!onglets.length) return;

    function montrer(i) {
      onglets.forEach(function (o, k) {
        var actif = k === i;
        o.classList.toggle('est-actif', actif);
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        o.setAttribute('tabindex', actif ? '0' : '-1');
      });
      fiches.forEach(function (f, k) { f.classList.toggle('est-actif', k === i); });
      var teinte = (onglets[i].style.getPropertyValue('--teinte') || '#2a9d6e').trim();
      bloc.style.setProperty('--teinte-active', teinte);
    }

    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { montrer(i); });
      o.addEventListener('keydown', function (ev) {
        if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
        ev.preventDefault();
        var j = ev.key === 'ArrowRight' ? (i + 1) % onglets.length : (i - 1 + onglets.length) % onglets.length;
        onglets[j].focus();
        montrer(j);
      });
    });

    montrer(0);
  });

  /* ----------------------------------------------------------------------
     4. L'en-tête se pose dès que la page bouge
     ---------------------------------------------------------------------- */
  var entete = document.querySelector('[data-ml-entete]');
  if (entete) {
    var enveloppe = document.querySelector('.page-wrapper');
    var attente = false;
    function juger() {
      attente = false;
      var y = (enveloppe && enveloppe.scrollTop) || window.scrollY || document.documentElement.scrollTop || 0;
      entete.classList.toggle('est-pose', y > 24);
    }
    document.addEventListener('scroll', function () {
      if (!attente) { attente = true; requestAnimationFrame(juger); }
    }, { passive: true, capture: true });
    juger();
  }

  /* ----------------------------------------------------------------------
     7. Fiche produit : le choix de la variante nourrit le formulaire
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-choix]').forEach(function (choix) {
    var select = choix.querySelector('[data-ml-select]');
    var champ = choix.closest('form') && choix.closest('form').querySelector('[data-ml-id]');
    if (!select || !champ) return;
    var attend = document.querySelectorAll('[data-ml-attend]');
    function suivre() {
      champ.value = select.value;
      var pret = !!select.value;
      Array.prototype.forEach.call(attend, function (bouton) {
        bouton.disabled = !pret;
        bouton.classList.toggle('est-en-attente', !pret);
      });
      document.querySelectorAll('[data-ml-attend-zone]').forEach(function (zone) {
        zone.classList.toggle('est-en-attente', !pret);
      });
    }
    select.addEventListener('change', suivre);
    suivre();

    /* On cherche son métier au lieu de dérouler quinze lignes. */
    var filtre = choix.querySelector('[data-ml-filtre]');
    if (filtre) {
      var tous = Array.prototype.slice.call(select.options).filter(function (o) { return o.value; }).map(function (o) {
        return { valeur: o.value, mot: o.textContent.trim(), bas: o.textContent.toLowerCase(), off: o.disabled };
      });
      filtre.dataset.vide = (select.options[0] && !select.options[0].value) ? select.options[0].textContent.trim() : '';
      filtre.addEventListener('input', function () {
        var q = filtre.value.trim().toLowerCase();
        var gardes = tous.filter(function (o) { return !q || o.bas.indexOf(q) >= 0; });
        if (!gardes.length) return;
        select.innerHTML = '';
        if (select.hasAttribute('data-ml-oblige') && gardes.length > 1) {
          var vide = document.createElement('option');
          vide.value = ''; vide.disabled = true; vide.selected = true;
          vide.textContent = filtre.dataset.vide || 'Choisissez votre métier';
          select.appendChild(vide);
        }
        gardes.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o.valeur; opt.textContent = o.mot; opt.disabled = o.off;
          select.appendChild(opt);
        });
        select.selectedIndex = 0;
        suivre();
      });
    }
  });

  /* ----------------------------------------------------------------------
     8. Faire connaître le produit : partage natif, sinon copie du lien
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-partage-bouton]').forEach(function (bouton) {
    var mot = bouton.querySelector('[data-ml-partage-mot]');
    var depart = mot ? mot.textContent : '';
    function confirmer() {
      if (!mot) return;
      mot.textContent = bouton.dataset.fait || 'Lien copié';
      bouton.classList.add('est-fait');
      setTimeout(function () {
        mot.textContent = depart;
        bouton.classList.remove('est-fait');
      }, 2400);
    }
    bouton.addEventListener('click', function () {
      var url = bouton.dataset.url;
      var titre = bouton.dataset.titre;
      if (navigator.share) {
        navigator.share({ title: titre, url: url }).then(function () {
          if (mot) { mot.textContent = 'Merci'; setTimeout(function () { mot.textContent = depart; }, 2000); }
        }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(confirmer).catch(function () {});
        return;
      }
      var boite = document.createElement('input');
      boite.value = url;
      document.body.appendChild(boite);
      boite.select();
      try { document.execCommand('copy'); confirmer(); } catch (e) {}
      document.body.removeChild(boite);
    });
  });

  /* ----------------------------------------------------------------------
     10. L'ajout au panier se voit : la pastille du panier tressaille
     ---------------------------------------------------------------------- */
  document.addEventListener('shopify:cart:lines-update', function (ev) {
    if (!ev || ev.action !== 'add') return;
    var pastille = document.querySelector('[data-ml-panier-pastille]') ||
                   document.querySelector('.header-actions__cart-icon, cart-icon-component');
    if (!pastille) return;
    pastille.classList.remove('est-ajoute');
    void pastille.offsetWidth;
    pastille.classList.add('est-ajoute');
    setTimeout(function () { pastille.classList.remove('est-ajoute'); }, 700);
  });

  /* ----------------------------------------------------------------------
     11. Les replis : ouverture douce, et un seul ouvert à la fois
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-replis]').forEach(function (groupe) {
    var replis = Array.prototype.slice.call(groupe.querySelectorAll('.ml-repli'));
    replis.forEach(function (repli) {
      var bouton = repli.querySelector('.ml-repli__tete');
      if (!bouton) return;
      bouton.addEventListener('click', function () {
        var ouvert = repli.classList.contains('est-ouvert');
        if (groupe.hasAttribute('data-ml-un-seul')) {
          replis.forEach(function (r) {
            r.classList.remove('est-ouvert');
            var b = r.querySelector('.ml-repli__tete');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        repli.classList.toggle('est-ouvert', !ouvert);
        bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      });
    });
  });

  /* ----------------------------------------------------------------------
     12. La bande du héros : elle avance d'elle-même, on peut la pousser du
     doigt ou à la souris, et elle s'arrête dès qu'on s'en occupe.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-bande]').forEach(function (cadre) {
    var vitesse = 0.35;
    var arrete = false, dedans = false;
    var tire = false, departX = 0, departScroll = 0, bouge = false;

    function avancer() {
      if (!arrete && !dedans && !tire && !reduit) {
        cadre.scrollLeft += vitesse;
        if (cadre.scrollLeft >= cadre.scrollWidth - cadre.clientWidth - 1) cadre.scrollLeft = 0;
      }
      requestAnimationFrame(avancer);
    }

    cadre.addEventListener('pointerenter', function () { dedans = true; });
    cadre.addEventListener('pointerleave', function () { dedans = false; });
    cadre.addEventListener('focusin', function () { arrete = true; });
    cadre.addEventListener('wheel', function () { arrete = true; }, { passive: true });
    cadre.addEventListener('touchstart', function () { arrete = true; }, { passive: true });

    cadre.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      tire = true; bouge = false;
      departX = ev.clientX; departScroll = cadre.scrollLeft;
      cadre.classList.add('est-tire');
    });
    window.addEventListener('pointermove', function (ev) {
      if (!tire) return;
      var d = ev.clientX - departX;
      if (Math.abs(d) > 4) bouge = true;
      cadre.scrollLeft = departScroll - d;
    });
    window.addEventListener('pointerup', function () {
      if (!tire) return;
      tire = false; arrete = true;
      cadre.classList.remove('est-tire');
    });
    /* Un glissement ne doit pas ouvrir la fiche par mégarde. */
    cadre.addEventListener('click', function (ev) {
      if (bouge) { ev.preventDefault(); ev.stopPropagation(); bouge = false; }
    }, true);

    cadre.scrollLeft = 0;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { dedans = !e[0].isIntersecting; }, { threshold: 0.1 }).observe(cadre);
    }
    requestAnimationFrame(avancer);
  });

  /* ----------------------------------------------------------------------
     13. Le bandeau d'achat collant : il prend le relais quand le bouton part
     ---------------------------------------------------------------------- */
  var colle = document.querySelector('[data-ml-colle]');
  var ajouter = document.querySelector('[data-ml-ajouter]');
  if (colle && ajouter) {
    colle.hidden = false;
    /* Quand un choix est obligatoire, la banniere y ramene au lieu de ne rien faire. */
    var choisir = colle.querySelector('[data-ml-colle-choisir]');
    if (choisir) {
      choisir.addEventListener('click', function () {
        var bloc = document.querySelector('[data-ml-choix]');
        if (!bloc) return;
        var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        bloc.scrollIntoView({ block: 'center', behavior: doux });
        var champ = bloc.querySelector('[data-ml-filtre]') || bloc.querySelector('[data-ml-select]');
        if (champ) setTimeout(function () { champ.focus({ preventScroll: true }); }, doux === 'smooth' ? 500 : 0);
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        colle.classList.toggle('est-la', !entrees[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(ajouter);
    }
  }

  /* ----------------------------------------------------------------------
     14. La foire aux questions cachée dans une description devient des replis
     Corrigé à la source : on ne réécrit pas le texte du produit, on le range.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-ranger-questions]').forEach(function (corps) {
    var titres = Array.prototype.slice.call(corps.querySelectorAll('h2'));
    var depart = null;
    titres.forEach(function (h) {
      var mot = (h.textContent || '').toLowerCase();
      if (!depart && (mot.indexOf('question') >= 0 || mot.indexOf('fréquent') >= 0)) depart = h;
    });
    if (!depart) return;
    var groupe = document.createElement('div');
    groupe.className = 'ml-replis';
    groupe.setAttribute('data-ml-replis', '');
    groupe.setAttribute('data-ml-un-seul', '');
    var noeud = depart.nextElementSibling;
    var courant = null;
    while (noeud) {
      var suivant = noeud.nextElementSibling;
      if (noeud.tagName === 'H2') break;
      if (noeud.tagName === 'H3') {
        courant = document.createElement('div');
        courant.className = 'ml-repli';
        var tete = document.createElement('button');
        tete.type = 'button';
        tete.className = 'ml-repli__tete';
        tete.setAttribute('aria-expanded', 'false');
        tete.innerHTML = '<span>' + noeud.innerHTML + '</span><span class="ml-repli__signe" aria-hidden="true"></span>';
        var corpsRepli = document.createElement('div');
        corpsRepli.className = 'ml-repli__corps';
        corpsRepli.appendChild(document.createElement('div'));
        courant.appendChild(tete);
        courant.appendChild(corpsRepli);
        groupe.appendChild(courant);
        noeud.remove();
      } else if (courant) {
        courant.querySelector('.ml-repli__corps > div').appendChild(noeud);
      }
      noeud = suivant;
    }
    if (groupe.children.length) {
      depart.insertAdjacentElement('afterend', groupe);
      groupe.querySelectorAll('.ml-repli__tete').forEach(function (bouton) {
        bouton.addEventListener('click', function () {
          var repli = bouton.closest('.ml-repli');
          var ouvert = repli.classList.contains('est-ouvert');
          groupe.querySelectorAll('.ml-repli').forEach(function (r) {
            r.classList.remove('est-ouvert');
            var b = r.querySelector('.ml-repli__tete');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          repli.classList.toggle('est-ouvert', !ouvert);
          bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
        });
      });
    }
  });

  /* ----------------------------------------------------------------------
     15. Le panier vit : la quantité se change et la ligne se retire sans
     quitter la page, et le reste du site en est informé.
     ---------------------------------------------------------------------- */
  var panier = document.querySelector('[data-ml-panier]');
  if (panier) {
    var occupe = false;
    function changer(ligne, quantite) {
      if (occupe) return;
      occupe = true;
      panier.classList.add('est-occupe');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: ligne, quantity: quantite })
      })
        .then(function (r) { return r.json(); })
        .then(function (corbeille) {
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
            detail: { itemCount: corbeille.item_count }, bubbles: true
          }));
          return fetch(location.pathname + '?section_id=' + panier.dataset.section);
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var boite = document.createElement('div');
          boite.innerHTML = html;
          var neuf = boite.querySelector('[data-ml-panier]');
          if (neuf && panier.parentNode) {
            panier.parentNode.replaceChild(neuf, panier);
            panier = neuf;
            brancher();
            paraitre(panier);
          }
        })
        .catch(function () {})
        .then(function () { occupe = false; if (panier) panier.classList.remove('est-occupe'); });
    }
    function brancher() {
      panier.querySelectorAll('[data-ml-ligne]').forEach(function (ligne) {
        var n = parseInt(ligne.getAttribute('data-ml-ligne'), 10);
        var nombre = ligne.querySelector('[data-ml-nombre]');
        var q = nombre ? parseInt(nombre.textContent, 10) || 1 : 1;
        var moins = ligne.querySelector('[data-ml-moins]');
        var plus = ligne.querySelector('[data-ml-plus]');
        var retirer = ligne.querySelector('[data-ml-retirer]');
        if (moins) moins.addEventListener('click', function () { changer(n, Math.max(0, q - 1)); });
        if (plus) plus.addEventListener('click', function () { changer(n, q + 1); });
        if (retirer) retirer.addEventListener('click', function () { changer(n, 0); });
      });
    }
    brancher();
  }

  /* ----------------------------------------------------------------------
     16. L'ajout au panier se voit : le bouton dit ce qu'il fait, tout de suite
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-ajouter], [data-ml-colle-bouton]').forEach(function (bouton) {
    var mot = bouton.querySelector('span');
    if (!mot) return;
    var depart = mot.textContent;
    bouton.addEventListener('click', function () {
      if (bouton.dataset.mlOccupe) return;
      bouton.dataset.mlOccupe = '1';
      bouton.classList.add('est-en-cours');
      mot.textContent = bouton.dataset.mlEnCours || 'Ajout en cours…';
    });
    document.addEventListener('shopify:cart:lines-update', function (ev) {
      if (!ev || ev.action !== 'add' || !bouton.dataset.mlOccupe) return;
      function fini() {
        bouton.classList.remove('est-en-cours');
        bouton.classList.add('est-fait');
        mot.textContent = bouton.dataset.mlFait || 'Ajouté au panier';
        setTimeout(function () {
          bouton.classList.remove('est-fait');
          mot.textContent = depart;
          delete bouton.dataset.mlOccupe;
        }, 2200);
      }
      Promise.resolve(ev.promise).then(fini).catch(fini);
      setTimeout(fini, 1500);
    });
  });

  /* ----------------------------------------------------------------------
     17. Toute zone qui défile le dit, et se pousse au clic
     Le code ne visait qu'une seule bande, celle du héros, et cherchait ses
     flèches par un nom qui lui était propre. Les onglets de niveau et la
     galerie d'une fiche débordaient donc sans rien montrer : leur barre de
     défilement est masquée, et personne ne devine une suite invisible.
     Une seule écriture sert désormais les trois, et servira la prochaine.
     ---------------------------------------------------------------------- */
  document.querySelectorAll('[data-ml-defile]').forEach(function (cadre) {
    var zone = cadre.closest('.ml-defile-zone');
    if (!zone) return;
    var recul = zone.querySelector('[data-ml-recul]');
    var avance = zone.querySelector('[data-ml-avance]');
    if (!recul || !avance) return;

    /* Un pas, c'est un élément : une carte, un onglet, une image. */
    function pas() {
      var piste = cadre.firstElementChild;
      var element = piste && piste.children.length ? piste.firstElementChild : cadre.firstElementChild;
      if (!element) return cadre.clientWidth * 0.8;
      var parent = element.parentElement;
      var trou = parseFloat(getComputedStyle(parent).columnGap || '0');
      return element.getBoundingClientRect().width + (isNaN(trou) ? 0 : trou);
    }
    function montrer() {
      var reste = cadre.scrollWidth - cadre.clientWidth;
      if (reste < 8) { recul.hidden = true; avance.hidden = true; return; }
      recul.hidden = cadre.scrollLeft < 8;
      avance.hidden = cadre.scrollLeft > reste - 8;
    }
    function pousser(sens) {
      var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      var avant = cadre.scrollLeft;
      var bout = cadre.scrollWidth - cadre.clientWidth;
      var cible = Math.max(0, Math.min(bout, avant + sens * pas()));
      cadre.scrollBy({ left: sens * pas(), behavior: doux });
      /* Filet : là où le défilement doux n’aboutit pas, on pose la position. */
      setTimeout(function () {
        if (Math.abs(cadre.scrollLeft - avant) < 2) cadre.scrollLeft = cible;
        montrer();
      }, 280);
    }
    avance.addEventListener('click', function () { pousser(1); });
    recul.addEventListener('click', function () { pousser(-1); });
    cadre.addEventListener('scroll', montrer, { passive: true });
    window.addEventListener('resize', montrer);
    /* La largeur d’un cadre change avec ses images et avec la fenêtre. */
    if ('ResizeObserver' in window) new ResizeObserver(montrer).observe(cadre);
    montrer();
    setTimeout(montrer, 600);
  });
})();
